import IncidentCard from './IncidentCard';

export default IncidentCard;
